import React from 'react'

import ActionTooltip from '../../ActionTooltip/ActionTooltip'
import Tooltip from '../../Tooltip/Tooltip'
import TableRow from './TableRow'
import RenderCell from './RenderCell'
import SingleRowSelectedUi from '../Features/SingleRowSelect'

import { EMPTY_ROW_ID } from '../util'

const ComposeTableRow = (props) => {
  //v2 features
  if (props.v2Features.tableRowAction && props.tableRowActionList) {
    return (
      <TableRow {...props}>
        <RenderCell {...props} />
      </TableRow>
    )
  }

  if (props.tableRowActionList && props.row.id !== EMPTY_ROW_ID) {
    return (
      <TableRow {...props}>
        <ActionTooltip list={props.tableRowActionList} data={props.row.original} right={props.toolTipPosFromRight}>
          <RenderCell {...props} />
        </ActionTooltip>
      </TableRow>
    )
  }

  if (props.isSingleRowSelected) {
    return (
      <TableRow {...props}>
        <SingleRowSelectedUi>
          <RenderCell {...props} />
        </SingleRowSelectedUi>
      </TableRow>
    )
  }

  if (props.disabledMessage && props.isRowDisabled) {
    return (
      <TableRow {...props}>
        <Tooltip content={props.disabledMessage} position="top" showArrow={false}>
          <RenderCell {...props} />
        </Tooltip>
      </TableRow>
    )
  }

  return (
    <TableRow {...props}>
      <RenderCell {...props} />
    </TableRow>
  )
}

export default ComposeTableRow